import { useMutation, useQueryClient } from '@tanstack/react-query';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useAddFriendsToGroup(groupId: number | null | undefined) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, number[]>({
    mutationKey: ['/CheckGroupManualVerified', groupId],
    mutationFn: (params) =>
      fetcher(
        '/CheckGroupManualVerified',
        {
          GroupID: groupId,
          UserIDs: params.join('|'),
        },
        { validResponseCodes: [0] },
      ),
    onSuccess: () => queryClient.refetchQueries(generateGroupInfoQueryOptions(groupId)),
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}
